import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { readContract } from "@wagmi/core"

import { veNftMinimalAbi } from "@/domains/abis"

type HasApprovedSuperVoterProps = {
  account: Address
  chainId: number
  config: Config
  veNftAddress: Address
  superVoterAddress: Address
}

/**
 * Check if the account has approved SuperVoter access to their NFTs
 */
export const hasApprovedSuperVoter = async ({
  account,
  chainId,
  config,
  veNftAddress,
  superVoterAddress,
}: HasApprovedSuperVoterProps) => {
  try {
    const access = await readContract(config, {
      abi: veNftMinimalAbi,
      address: veNftAddress,
      functionName: "isApprovedForAll",
      args: [account, superVoterAddress],
      chainId,
    })

    return access
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("hasApprovedSuperVoter", error)
  }

  return false
}
